import axios from "axios";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAlert, updateUnapprovedModels, updateModels, updateProjectNamesAndIdsOfUser, updateModelInputTypes, updateModelResultTypes } from "../../redux/actions";
import "./index.css";
import {
  // Pagination,
  useMediaQuery,
} from "@mui/material";
import { MdAdd } from "react-icons/md";
import { FaStar } from "react-icons/fa";
import { useTheme } from "@mui/material/styles";
import NewCard from "../../components/NewCard";
import ContextMenu from "../../../../common/ContextMenu";
import SearchBar from "../../components/SelectField/SearchBar";
import EditModel from "./components/EditModel";
import AddModel from "./components/AddModel";
import RemoveModel from "./components/RemoveModel";

function Models(props) {
  const navigate = useNavigate();
  const [reload, setReload] = useState(false);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [models, setModels] = useState([]);
  const [allModels, setAllModels] = useState([]);
  const [unapprovedModels, setUnapprovedModels] = useState([]);
  const [favActive, setFavActive] = useState(false);


  // ---------- delete model ----------
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const [selectedModel, setSelectedModel] = useState({});

  useEffect(() => {
    if (!props.user.id) {
      navigate("/");
    }
    if (props.models === null || reload) {
      axios({
        method: "get",
        url: `/api/m2d/models`,
      }).then((res) => {
        setReload(false)
        setModels(res.data);
        setAllModels(res.data);
        props.handleModels(res.data);
      }).catch((err) => {
        props.handleAlert("error", err.message, 3000);
      });
    } else {
      setModels(props.models);
    }
  }, [reload, navigate, props]);

  useEffect(() => {
    if (props.unapprovedModels === null || reload) {
      axios({
        method: "post",
        url: "/api/m2d/models/getUnapprovedModels",
        data: {
          uid: props.user.id
        }
      }).then(res => {
        setReload(false)
        if (res.data.length > 0) {
          setUnapprovedModels(res.data[0].m2dModels)
          props.handleUnapprovedModels(res.data[0].m2dModels)
        } else {
          props.handleUnapprovedModels([])
        }
      })
    } else {
      setUnapprovedModels(props.unapprovedModels)
    }

  }, [reload, props])

  const handleMore = (id) => {
    if (props.user.id) {
      navigate(`/m2d/models/${id}`);
    }
  };

  const handleAddModel = () => {
    setOpen(true);
  };

  const handleFav = () => {
    if (favActive) {
      setFavActive(false);
      setModels(allModels);
      return
    }
    setFavActive(true);
    setModels(curr => curr.filter(
      model => model.m2dModelStars &&
        model.m2dModelStars.length > 0 &&
        model.m2dModelStars.find(ms => ms.userId === props.user.id)
    ));

  }

  const handleOpen = (id) => () => {
    navigate(`/m2d/models/${id}`)
  }

  const handleEdit = (id) => () => {
    let m = models.find(model => model.id === id)
    if (!m) {
      m = unapprovedModels.find(model => model.id === id)
    }
    if (m.users.find(user => user.id === props.user.id) || props.role === "Admin") {
      setSelectedModel(m);
      setEditOpen(true);
    }

  }

  const handleRemove = (id) => () => {
    // props.handleAlert("error", "This function is under construction!", 3000)
    setDeleteConfirmOpen(true)
    const currModel = models.find(model => model.id === id)
    if (currModel) {
      setSelectedModel(currModel)
    } else {
      setSelectedModel(unapprovedModels.find(model => model.id === id))
    }
  }

  const getMenuItems = (id) => {
    let selectedModel = models.find(model => model.id === id)
    if (!selectedModel) {
      selectedModel = unapprovedModels.find(model => model.id === id)
    }

    const menuItems = [
      { label: 'Open', action: handleOpen(id) },
    ];

    if (selectedModel.users.find(user => user.id === props.user.id) || props.role === "Admin") {
      menuItems.push(
        { label: 'Edit', action: handleEdit(id) },
        { label: 'Remove', action: handleRemove(id) },
      )
    }

    return menuItems;
  }

  const handleKeyDown = (e, content) => {
    // when press enter
    if (e.keyCode === 13) {
      e.preventDefault();
      if (content.length === 0) {
        // if empty search
        setModels(allModels);
        setFavActive(false);
      } else {
        const results = allModels.filter(model => model.name.toLowerCase().indexOf(content.toLowerCase()) !== -1);
        setModels(results);
      }
    }
  }

  return (
    <>
      <div className="tool-bar">
        <div className="searchbar">
          <SearchBar
            placeholder="Search models"
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className={`element${favActive ? "-active" : ""}`} onClick={handleFav}>
          <div className="icon">
            <FaStar style={{
              fontSize: '20px',
              marginTop: '5px',
              marginRight: '10px'
            }} />
          </div>
          <span>My favorites</span>
        </div>
        {["Admin", "Internal"].includes(props.role) ? (
          <div className="element" onClick={handleAddModel}>
            <div className="icon">
              <MdAdd style={{
                fontSize: '20px',
                marginTop: '5px',
                marginRight: '10px'
              }} />
            </div>
            <span>Create model</span>
          </div>) : null}
      </div>
      <div className="page-content">
        <div className="model-content">
          {unapprovedModels.map((model) => {
            return (
              <ContextMenu menuItems={getMenuItems(model.id)} key={model.id}>
                <NewCard model={model} approved={false} handleMore={() => handleMore(model.id)} key={model.id} />
              </ContextMenu>
            )
          })}
          {models.map((model) => {
            return (
              <ContextMenu menuItems={getMenuItems(model.id)} key={model.id}>
                <NewCard model={model} approved handleMore={() => handleMore(model.id)} key={model.id} />
              </ContextMenu>
            )
          })}
        </div>

        <div className="add-proj-content">
          {/* ---------- create model ---------- */}
          <AddModel
            open={open}
            setOpen={setOpen}
            fullScreen={fullScreen}
          />

          {/* ---------- edit model ---------- */}
          <EditModel
            open={editOpen}
            setOpen={setEditOpen}
            selectedModel={selectedModel}
            setReload={setReload}
            fullScreen={fullScreen}
          />
        </div>

        {/* ---------- delete model ---------- */}

        <RemoveModel
          open={deleteConfirmOpen}
          setOpen={setDeleteConfirmOpen}
          selectedModel={selectedModel}
          setReload={setReload}
          reload={reload}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    models: state.m2d.models,
    unapprovedModels: state.m2d.unapprovedModels,
    projectNamesAndIdsOfUser: state.m2d.projectNamesAndIdsOfUser,
    modelInputTypes: state.m2d.modelInputTypes,
    modelResultTypes: state.m2d.modelResultTypes,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleModels(models) {
      updateModels(models)(dispatch);
    },

    handleUnapprovedModels(models) {
      updateUnapprovedModels(models)(dispatch)
    },

    handleProjectNamesAndIdsOfUser(projectNamesAndIdsOfUser) {
      updateProjectNamesAndIdsOfUser(projectNamesAndIdsOfUser)(dispatch)
    },

    handleModelInputTypes(modelInputTypes) {
      updateModelInputTypes(modelInputTypes)(dispatch)
    },

    handleModelResultTypes(modelResultTypes) {
      updateModelResultTypes(modelResultTypes)(dispatch)
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Models);
